import { AgreementContext } from "@sb1finans/components/dist/AgreementContext"
import { Account, VendorsApi } from "@sb1finans/new-api/dist"
import { createContext, useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useAgreementId } from "../hooks"

interface AccountContextProps {
    accounts: Account[]
}

export const AccountContext = createContext<AccountContextProps>({accounts: []})

interface AccountProviderProps {
    children: React.ReactNode
    vendorsApi: VendorsApi
}

export const AccountProvider: React.FC<AccountProviderProps> = ({vendorsApi, children}) => {

    const [accounts, setAccounts] = useState<Account[]>([])
    const { agreementId: activeAgreementId } = useAgreementId()

    const fetchAccounts = async (agreementId: string) => {
        const response = await vendorsApi.listVendorAccounts(agreementId)
        setAccounts(response.data)
    }

    console.log("WHAT IS AGREEMENT ID", activeAgreementId)
    useEffect(() => {
        if (!activeAgreementId) return
        fetchAccounts(activeAgreementId)
    }, [activeAgreementId])

    return (
        <AccountContext.Provider value={{accounts}}>
            {children}
        </AccountContext.Provider>
    )
}